// src/components/LoginEmail.jsx
import React from "react";
import Input from "../components/Input";
import Button from "../components/Button";
import { useSelector } from "react-redux";
import Spinner from "../components/Spinner";

function LoginEmail({ email, error, handleInputChange, handleButtonClick }) {
  const sendOTPState = useSelector((state) => state.sendOTP);

  return (
    <>
      <div className="leap-scale-75 md:leap-scale-90 xl:leap-scale-90 2xl:leap-scale-105 leap-items-center leap-flex-row leap-my-auto leap-flex leap-gap-4 leap-justify-center">
        {sendOTPState?.loading ? (
          <Spinner />
        ) : (
          // ""
          <>
            <div className="">
              <div
                className="!leap-rounded-[16px] leap-mx-auto 2xl:leap-mx-0 leap-py-[1px] leap-px-[1.1px] !leap-w-full md:!leap-w-[20rem] 2xl:!leap-w-[30rem] xl:!leap-w-[35rem]"
                style={{
                  background:
                    "linear-gradient(180deg, #EB3DF7 0%, #3B29AB 50%, #73FAFD 100%)",
                }}
              >
                <Input
                  type="email"
                  placeholder="Your Email"
                  value={email}
                  onChange={handleInputChange}
                  borderColor="#73FAFD"
                  className="leap-h-full leap-text-white  md:!leap-w-[20rem] 2xl:!leap-w-[30rem] xl:!leap-w-[35rem]"
                  id="emailInput"
                  autoComplete="off"
                />
              </div>
              {/* {error && (
                <p className="leap-text-red-500 leap-font-bold leap-text-[12px] md:leap-text-base lg:leap-text-xl">
                  {error}
                </p>
              )} */}
            </div>
            <div className="">
              <Button
                text="Verify"
                bgColor="#73FAFD"
                textColor="black"
                customStyles="leap-uppercase !leap-text-base 2xl:!leap-text-xl !leap-min-w-20 2xl:!leap-min-w-44"
                onClick={handleButtonClick}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default LoginEmail;
